export default __webpack_public_path__ + "static/media/Campus.03784cd1.jpg";